module.exports = __webpack_public_path__ + "static/prot-neuro-deec4327a105176cca101c466aef00d7.jpg";